// std140 layout: each mat4 is 64 bytes, sequential, no padding.
export const MAX_BONES = 32;
export const BONE_UBO_BYTES = MAX_BONES * 16 * 4;
export const BONE_UBO_BINDING = 0;

export interface BoneUbo {
  buffer: WebGLBuffer;
}

export const createBoneUbo = (gl: WebGL2RenderingContext): BoneUbo => {
  const buffer = gl.createBuffer();
  if (buffer === null) throw new Error('gl ubo allocation failed');
  gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
  gl.bufferData(gl.UNIFORM_BUFFER, BONE_UBO_BYTES, gl.DYNAMIC_DRAW);
  gl.bindBuffer(gl.UNIFORM_BUFFER, null);
  gl.bindBufferBase(gl.UNIFORM_BUFFER, BONE_UBO_BINDING, buffer);
  return { buffer };
};

export const uploadBonePalette = (
  gl: WebGL2RenderingContext,
  ubo: BoneUbo,
  palette: Float32Array,
): void => {
  if (palette.length > MAX_BONES * 16) {
    throw new Error(`bone palette exceeds MAX_BONES (${MAX_BONES})`);
  }
  gl.bindBuffer(gl.UNIFORM_BUFFER, ubo.buffer);
  gl.bufferSubData(gl.UNIFORM_BUFFER, 0, palette);
  gl.bindBuffer(gl.UNIFORM_BUFFER, null);
};

export const disposeBoneUbo = (gl: WebGL2RenderingContext, ubo: BoneUbo): void => {
  gl.deleteBuffer(ubo.buffer);
};
